<template>
  <base-draggable-modal
      name="base_link_procedure_step"
      max-height="80vh"
      width="70vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="base_link_procedure_step">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate("add") + ' ' + $store.getters.translate("procedurestep") }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-data-table
                :headers="fields"
                :items="getRecords"
                class="elevation-1"
                item-value="id"
                selectable-key="id"
                return-object
                show-select
                v-model="selected"
                v-bind="footer_props"
                v-model:items-per-page="options.itemsPerPage"
                v-model:page="options.page">
              <template #body="{ items }">
                <tr v-for="item in items" :key="item.id" class="sm-normal text-primary">
                  <td>
                    <v-checkbox color="success" density="compact" v-model="selected" :key="item.id" :value="item"/>
                  </td>
                  <td v-for="(key, index) in Object.keys(response_fields)" :key="index" @click.exact="addToSelect(item)">
                    <base-field-in-table :item="item" :field_name="key" :field_type="response_fields[key]" page_name="proceduresteps"/>
                  </td>
                </tr>
                <tr v-if="getRecords.length === 0">
                  <td :colspan="fields.length + 1" class="text-center">
                    <span class="sm-normal link">{{ $store.getters.translate("nothing_found") }}</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import {useAbility} from "@casl/vue";
import helpFunctions from "../../plugins/helpFunctions.js";
import BaseFieldInTable from "./BaseFieldInTable";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  components: { BaseActionButton, BaseFieldInTable, BaseDraggableModal, BaseModal, PhFloppyDisk, PhX },
  props: ["parent_id", "excluded_names"],
  setup() {
    const { can } = new useAbility();
    return { can }
  },
  data() {
    return {
      records: [],
      selected: [],
      options: helpFunctions.table_options,
      footer_props: helpFunctions.footer_props,
      response_fields: {},
      fields: [],
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.openModal('base_link_procedure_step');
      let response = await helpFunctions.getModelsForTables(this.$toast, "proceduresteps");
      this.records = response.data;
      this.response_fields = helpFunctions.replaceIDwithNameBaseTable(response.fields);
      this.fields = helpFunctions.composeFields(this.response_fields, false);
      if (this.excluded_names) {
        this.records = this.records.filter((record) => !this.excluded_names.includes(record.name));
      }
    },
    async save() {
      this.$store.dispatch('setLoader', true);
      for (let i = 0; i < this.selected.length; i++) {
        await helpFunctions.createModelSilently("procedureresults", {procedure_id: this.parent_id, name: this.selected[i].name, description: this.selected[i].description});
      }
      this.$store.dispatch('setLoader', false);
      this.$toast.success(this.$store.getters.translate("successfully_saved"));
      this.$emit('refresh');
      this.reset();
    },
    async addToSelect(item) {
      if (!this.selected.includes(item)) {
        this.selected.push(item);
      }
      await this.save();
    },
    reset() {
      this.closeModal('base_link_procedure_step');
      this.records = [];
      this.selected = [];
    },
  },
  computed: {
    getRecords() {
      if(this.records) {
        return this.records;
      }
      else {
        return [];
      }
    },
  },
};
</script>

<style scoped>
.v-checkbox {
  display: flex;
}
</style>